import Model from "../Model";

class UserType extends Model{

    buildUrl ({ param }) {
        return ['/usertype', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new UserType;